/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2026, Bulb Inc.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { AeroModule } from '../../aero/aero.module';
import { BulbCommonModule } from '../../common/bulb-common.module';
import { AccountEmailsComponent } from './account-emails.component';
import { AccountSettingsComponent } from './account-settings.component';
import { AccountVerifyEmailComponent } from './account-verify-email.component';
import { AccountPhoneInputDirective } from './phone-input.directive';
import { AccountPhoneNumberPipe } from './phone-number.pipe';
import { AddEmailComponent } from './add-email.component';
import { JoinGroupComponent } from './join-group.component';
import { ParentAccountsComponent } from './parent-accounts.component';
import { AccountAjaxValidationDirective } from './account-validation.directive';
import { AccountValidationFieldMatchDirective } from './account-validation-field-match.directive';
import { BulbValidationFieldDirective } from './bulb-validation-field.directive';
import { AddCouponComponent } from './add-coupon.component';
import { PushNotificationServiceProvider } from '../angularjs.providers';
import { MobileLauncherModule } from '../mobile-launcher/mobile-launcher.module';

/** Angular module for the migrated Account Settings screens. */
@NgModule({
  declarations: [
    AccountSettingsComponent,
    AccountEmailsComponent,
    AccountPhoneNumberPipe,
    AccountPhoneInputDirective,
    AddEmailComponent,
    AccountVerifyEmailComponent,
    JoinGroupComponent,
    ParentAccountsComponent,
    AccountAjaxValidationDirective,
    AccountValidationFieldMatchDirective,
    BulbValidationFieldDirective,
    AddCouponComponent,
  ],
  imports: [
    AeroModule,
    BulbCommonModule,
    CommonModule,
    FormsModule,
    TranslocoModule,
    MobileLauncherModule,
  ],
  providers: [
    PushNotificationServiceProvider,
  ],
  exports: [
    AccountSettingsComponent,
    AccountVerifyEmailComponent,
  ],
})
export class AccountSettingsModule {}
